module.exports = __webpack_public_path__ + "static/media/safari-pinned-tab.6c31b0e2.svg";